module.exports = __webpack_public_path__ + "static/img/bg.f646622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page7/bg.png
// module id = gZsY
// module chunks = 0